/* eslint-disable @typescript-eslint/no-explicit-any */
import { uuid4 } from '@/@corefabriccanvas/utils';
import { get, set } from '@/data/ionicStorage';
import { formatDateToString } from '@/utility/utils';

// Kullanıcı sayfası için arabirim tanımlaması
export interface BlankPage {
  id: string | null;
  userId: string;
  title: string;
  json?: string;
  bookId: number;
  paperType: string;
  dataUrl: string;
  createdDate: string;
  cropArea?: any;
}

const addNewPage = (userId: string, bookId: number): BlankPage => {
  return {
    id: null,
    userId: userId,
    title: '',
    json: '',
    bookId: bookId,
    paperType: '',
    dataUrl: '',
    createdDate: formatDateToString(new Date()),
  };
};
export const saveUserPage = async (
  blankPage: BlankPage,
): Promise<BlankPage> => {
  try {
    const savedPages: BlankPage[] = (await get('blankPages')) as BlankPage[] || [];
    const index = savedPages.findIndex((page) => page.id === blankPage.id);
    if (blankPage.id) {
      if (index !== -1) {
        savedPages[index] = { ...savedPages[index], ...blankPage };
      } else {
        throw new Error(`Page with id ${blankPage.id} not found for update.`);
      }
    } else {
      blankPage.id = uuid4();
      savedPages.push(blankPage);
    }
    await set('blankPages', savedPages);
    return blankPage;
  } catch (err) {
    return Promise.reject(
      `Error saving user page: ${err instanceof Error ? err.message : err}`,
    );
  }
};

export const getUserPages = async (
  userId: string,
  bookId: number,
  crateEmptyPage: boolean = false,
): Promise<BlankPage[]> => {
  try {
    const savedPages: BlankPage[] = await get('blankPages') as BlankPage[] || [];
    if (crateEmptyPage) {
      const emptyPage= addNewPage(userId, bookId);
      savedPages.push(emptyPage);
    }
    const pageList = savedPages?.filter(
      (x) => x.userId === userId && x.bookId === bookId,
    );
    return pageList?.reverse();
  } catch (err) {
    return Promise.reject(`Error: ${err}`);
  }
};

export const deleteUserPage = async (id: string): Promise<void> => {
  try {
    const savedPages: BlankPage[] = await get('blankPages') as BlankPage[];
    const updatedSavedPages = savedPages.filter((x) => x.id !== id);
    await set('blankPages', updatedSavedPages);
  } catch (err) {
    return Promise.reject(`Error: ${err}`);
  }
};
